<template>
  <!-- 任务列表 -->
  <div class="dialog-root">
    <div class="container">
      <avue-crud
        ref="crud"
        :option="tableOption"
        :data="listData"
        :page.sync="tablePage"
        @on-load="loadData"
        @selection-change="selectionChange"
      >
      </avue-crud>
    </div>
    <!-- 按钮占位区域 -->
    <div class="placeholder"></div>
    <!-- 底部操作按钮 -->
    <div class="btn">
      <el-button type="primary" size="small" @click="doSave">确定</el-button>
      <el-button size="small" @click="doClose">取消</el-button>
    </div>
  </div>
</template>

<script>
import { getTaskListApi, bindTaskApi } from '@/api/call-system/call-manage/AI-operator-manage';

export default {
  name: 'TaskList',
  props: ['projectId', 'rowData'],
  data() {
    return {
      // 列表数据
      listData: [],
      // 选中的项
      selectedList: [],
      // 表格分页信息
      tablePage: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      // 表格选项
      tableOption: {
        height: 'auto',
        calcHeight: 'auto',
        border: true,
        refreshBtn: false,
        columnBtn: false,
        searchShowBtn: false,
        selection: true,
        reserveSelection: true,
        addBtn: false,
        menu: false,
        dialogClickModal: false,
        column: [
          {
            label: '任务名称',
            prop: 'name',
          },
          {
            label: '开始时间',
            prop: 'startDate',
          },
          {
            label: '结束时间',
            prop: 'endDate',
          },
          {
            label: '时间段',
            prop: 'timePeriod',
          },
          {
            label: '优先级',
            prop: 'taskLevel',
            type: 'select',
            dicUrl: '/api/blade-system/dict/dictionary?code=callcenter_task_level',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
          },
        ],
      },
    };
  },
  methods: {
    /* 加载列表数据 */
    loadData(page) {
      page = page || this.tablePage;
      getTaskListApi({
        current: page.currentPage,
        size: page.pageSize,
        projectId: this.projectId,
      }).then(({ data }) => {
        this.tablePage.total = data.total;
        this.listData = data.records;
      });
    },
    /* 勾选项发生变化 */
    selectionChange(val) {
      this.selectedList = val;
    },
    doSave() {
      if (this.selectedList.length == 0) {
        this.$message.warning('请先勾选任务');
        return;
      }
      let ids = this.selectedList.map((item) => {
        return item.id;
      });
      bindTaskApi({
        serverAiId: this.rowData.id,
        taskIds: ids.join(','),
      }).then(() => {
        this.$message.success('操作成功!');
        this.doClose();
      });
    },
    doClose() {
      this.$emit('close');
      this.$refs.crud.toggleSelection();
      this.selectedList = [];
    },
  },
};
</script>

<style lang="scss" scoped>
.dialog-root {
  /* 给按钮的父元素加一个相对定位，方便按钮的布局 */
  position: relative;
  /* 内容容器 */
  .container {
    position: relative;
    box-sizing: border-box;
    width: 100%;
    max-height: 60vh;
    padding: 0 10px;
    overflow: scroll;
  }
  /* 按钮占位区域 */
  .placeholder {
    height: 50px;
  }
  /* 底部固定的按钮区域 */
  .btn {
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 50px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    background: #fff;
  }
}

/* 表单的每一项宽度最大化 */
::v-deep .el-form-item {
  width: 100%;
}

/* 去掉表格上方的空白区域 */
::v-deep .avue-crud__menu {
  display: none !important;
}
</style>
